namespace TabAurous.Common {
    export enum AdditionalChargesTransactionCalcon {
        Net = 1,
        Tax = 2,
        Gross = 3
    }
    Serenity.Decorators.registerEnumType(AdditionalChargesTransactionCalcon, 'TabAurous.Common.AdditionalChargesTransactionCalcon', 'Administration.AdditionalChargesTransaction');
}
